import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

export default {
  methods: {
    validaDebitosPorCpf() {
      const cpf = this.cpf.replace(/[^0-9]/g, "");
      if (cpf.length == 11) {
        this.cpfLoading = true;
        this.$axios(`/cliente/verificar-debito/cpf/${cpf}`).then((res) => {
          if (res.data.boletosVencidos === 0) {
            this.cpfEmDebito = false;
          } else {
            this.cpfEmDebito = true;
          }
          this.cpfLoading = false;
        });
      }
    },
  },

  data: () => ({
    rules: {
      nascimento: () => {
        return true;
        // let d = dayjs(value)
        //   .locale("pt-br")
        //   .format();
        // return (
        //   dayjs(d).isBetween(new Date(), dayjs("1910-01-01", "year")) ||
        //   "Data inválida"
        // );
      },
      nascimento18: (value) =>
        dayjs(value).isBetween(
          dayjs(new Date()).subtract(18, "year"),
          dayjs("1930-01-01", "year")
        ) || "Idade Inválida",
      required: (value) => !!value || "Campo Obrigatório.",
      max: (value) => value.length <= 40 || "Max 40 caracteres",
      password: (value) => value.length <= 15 || "Max 15 caracteres",
      min: (value) => value.length >= 5 || "Min 5 caracteres",
      rg: (value) => value.length == 12 || `RG incompleto`,
      cpfLength: (value) => value.length == 14 || `CPF incompleto`,
      celular: (value) => {
        let regex = /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}-[0-9]{4}$/;
        return regex.test(value);
      },
      word: (value) => {
        let regNum = /[0-9]/;
        let regSpec = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
        return (
          (!regNum.test(value) && !regSpec.test(value)) ||
          "Este campo deve conter apenas Letras"
        );
      },
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "e-mail Inválido.";
      },
      cpf: function(value) {
        function ValidarCPF(cpfRaw) {
          if (!cpfRaw) {
            return false;
          } else {
            let cpf = cpfRaw.replace(/[^0-9]/g, "");

            let somaCPF =
              cpf[0] * 10 +
              cpf[1] * 9 +
              cpf[2] * 8 +
              cpf[3] * 7 +
              cpf[4] * 6 +
              cpf[5] * 5 +
              cpf[6] * 4 +
              cpf[7] * 3 +
              cpf[8] * 2;
            let DigitoVerificador1 = (somaCPF * 10) % 11;

            if (DigitoVerificador1 == 10) DigitoVerificador1 = 0;
            let somaCPF2 =
              cpf[0] * 11 +
              cpf[1] * 10 +
              cpf[2] * 9 +
              cpf[3] * 8 +
              cpf[4] * 7 +
              cpf[5] * 6 +
              cpf[6] * 5 +
              cpf[7] * 4 +
              cpf[8] * 3 +
              DigitoVerificador1 * 2;
            let DigitoVerificador2 = (somaCPF2 * 10) % 11;

            if (DigitoVerificador2 == 10) {
              DigitoVerificador2 = 0;
            }

            if (cpf[9] == DigitoVerificador1 && cpf[10] == DigitoVerificador2)
              return true;
            else {
              return false;
            }
          }
        }
        return ValidarCPF(value) || "CPF Inválido";
      },
    },
  }),
};
